import { createTheme, darkScrollbar } from '@mui/material';
import type {} from '@mui/x-data-grid-pro/themeAugmentation'; // provides DataGrid in theme.palette
import {
  backgroundSecondaryDark,
  blueOnDark,
  darkBackground,
  teal,
} from './brandColors';
import { productionColors, sharedThemeTokens, typography } from './shared';

export const StackDark = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: blueOnDark,
      },
      secondary: {
        main: teal,
      },
      background: {
        default: darkBackground,
        paper: darkBackground,
        secondary: backgroundSecondaryDark,
      },
      DataGrid: {
        bg: darkBackground,
        headerBg: darkBackground,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: darkScrollbar(),
        },
      },
    },
    borderColor: 'rgba(255, 255, 255, 0.23)',
    productionColors,
    typography,
  },
  sharedThemeTokens
);
